import { render, staticRenderFns } from "./MiniGameRanking.vue?vue&type=template&id=7130e3ae&"
import script from "./MiniGameRanking.vue?vue&type=script&lang=js&"
export * from "./MiniGameRanking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports